import {
  CompoundTester,
  ModelArchitectureDiagram,
  ModelStatsBar,
  PerformanceCharts,
  ReferenceDBExplorer,
  RoMSHModelCard,
  TrainingDataOverview,
} from "@/components/ai-models";
import PipelineDiagram from "@/components/PipelineDiagram";
import { useAIHealth } from "@/hooks/useAIModels";
import { useAuth } from "@/hooks/useAuth";

export default function AIModelVisualizationPage() {
  const { user } = useAuth();
  const { data: health } = useAIHealth();

  return (
    <div className="space-y-8">
      {/* Header */}
      <div>
        <div className="flex items-center justify-between flex-wrap gap-2">
          <div>
            <h1 className="text-2xl font-bold text-gray-900">AI 모델 시각화</h1>
            <p className="text-sm text-gray-600 mt-1">
              인하대학교 AI 모델의 동작 원리와 성능을 확인합니다.
            </p>
          </div>
          <div className="flex items-center gap-3">
            {health && (
              <span
                className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium ${
                  health.status === "healthy"
                    ? "bg-green-100 text-green-700"
                    : "bg-red-100 text-red-700"
                }`}
              >
                <span
                  className={`w-1.5 h-1.5 rounded-full ${
                    health.status === "healthy" ? "bg-green-500" : "bg-red-500"
                  }`}
                />
                AI 서비스 {health.status === "healthy" ? "정상" : "오프라인"}
              </span>
            )}
            {user && (
              <span className="text-xs text-gray-500">{user.username}</span>
            )}
          </div>
        </div>
      </div>

      {/* 0. 데이터 흐름 다이어그램 (시연용 overview) */}
      <section className="mb-8">
        <h2 className="text-xl font-semibold text-gray-800 mb-4">
          데이터 흐름
        </h2>
        <PipelineDiagram />
      </section>

      {/* 1. Stats Bar */}
      <ModelStatsBar />

      {/* 2. Compound Tester (Hero) */}
      <CompoundTester />

      {/* 3. Model Architecture */}
      <ModelArchitectureDiagram />

      {/* 4. Performance Charts */}
      <PerformanceCharts />

      {/* 5. Reference DB Explorer */}
      <ReferenceDBExplorer />

      {/* 6. RoMSH Model Card (인하대 트랜스포머 혼합물 분류기) */}
      <RoMSHModelCard />

      {/* 7. Training Data Overview */}
      <TrainingDataOverview />
    </div>
  );
}
